export default __webpack_public_path__ + "static/media/wallet buy.a5fa9445.png";